import React from "react";
import MexicanCurrency from "../common/currency/index";

export const columns = [
  {
    Header: () => <p className="font-weight-bold">SISTEMA</p>,
    id: "sistema",
    width: 80,
    Cell: row => {
      return <p className="text-center"> {row.original.sistema || "N/A"} </p>;
    }
  },
  {
    Header: () => <p className="font-weight-bold">ID COMISION</p>,
    id: "idComision",
    width: 100,
    Cell: row => {
      return <p className="text-center"> {row.original.idComision} </p>;
    }
  },
  {
    Header: () => <p className="font-weight-bold">FOLIO FACTURA</p>,
    id: "folioFactura",
    width: 110,
    Cell: row => {
      return <p className="text-center"> {row.original.folioFactura} </p>;
    }
  },
  {
    Header: () => <p className="font-weight-bold">FECHA AUTORIZACION</p>,
    id: "fechaAutorizacion",
    width: 150,
    Cell: row => {
      return <p className="text-center"> {row.original.fechaAutorizacion} </p>;
    }
  },
  {
    Header: () => <p className="font-weight-bold">USUARIO AUTORIZACION</p>,
    id: "usuarioAutorizacion",
    Cell: row => {
      return (
        <p className="text-center"> {row.original.usuarioAutorizacion} </p>
      );
    }
  },
  {
    Header: () => <p className="font-weight-bold">CLUB</p>,
    id: "club",
    width: 120,
    Cell: row => {
      return <p className="text-center"> {row.original.club} </p>;
    }
  },
  {
    Header: () => <p className="font-weight-bold">TIPO COMISION</p>,
    id: "tipocomision",
    width: 170,
    Cell: row => {
      return <p className="text-center"> {row.original.tipocomision} </p>;
    }
  },
  {
    Header: () => <p className="font-weight-bold">ESTATUS</p>,
    id: "estatusComision",
    width: 100,
    Cell: row => {
      return <p className="text-center"> {row.original.estatusComision} </p>;
    }
  },
  {
    Header: () => <p className="font-weight-bold">IMPORTE</p>,
    id: "importe",
    width: 120,
    Cell: row => {
      return (
        <p className="font-weight-bold text-center">
          {" "}
          <MexicanCurrency quantity={row.original.importe} />{" "}
        </p>
      );
    }
  },
  {
    Header: () => <p className="font-weight-bold">DESCRIPCION</p>,
    id: "descripcion",
    Cell: row => {
      return <p className="text-center"> {row.original.descripcion} </p>;
    }
  },
  {
    Header: () => <p className="font-weight-bold">MONTO</p>,
    id: "montoComision",
    width: 120,
    Cell: row => {
      return (
        <p className="font-weight-bold text-center">
          {" "}
          <MexicanCurrency quantity={row.original.montoComision} />{" "}
        </p>
      );
    }
  },
  {
    Header: () => <p className="font-weight-bold">PORCENTAJE</p>,
    id: "porcentaje",
    width: 100,
    Cell: row => {
      return <p className="text-center"> {row.original.porcentaje} % </p>;
    }
  }
];
